import CallIcon from '@mui/icons-material/Call'
import Button from '@mui/material/Button'
import Icon from '@mui/material/Icon'
import { styled } from '@mui/material/styles'
import React from 'react'

import Tooltip from '@/app/component/atom/tooltip'
import IconText from '@/app/component/layout/icon-text'

import { EllipsisTypography, FlexContainerCenter } from './common'

interface Props {
  contactLabel: string
  onCallContact: () => void
}

const ContactDetails: React.FC<Props> = ({ contactLabel, onCallContact }) => (
  <ContactDetailsContainer>
    <IconText>
      <Icon>person</Icon>
      <Tooltip title={contactLabel}>
        <EllipsisTypography variant="h6">{contactLabel}</EllipsisTypography>
      </Tooltip>
    </IconText>
    <FlexContainerCenter style={{ minWidth: '150px' }}>
      <CallButton variant="contained" color="primary" onClick={onCallContact} startIcon={<CallIcon />}>
        Call contact
      </CallButton>
    </FlexContainerCenter>
  </ContactDetailsContainer>
)

const ContactDetailsContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  maxWidth: '50%',
})

const CallButton = styled(Button)({
  marginLeft: '15px',
})

export default ContactDetails
